const state = {
  language:''
}

const getters = {
  currentLanguage: (state, getters) => state.language
}

const mutations = {
  changeLanguage (state, lang) { state.language = lang }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/modules/language.js